type ChatState = { draft: string; scrollTop: number };

const stateByConversation = new Map<string, ChatState>();

export function getChatState(conversationId: string): ChatState {
  return stateByConversation.get(conversationId) ?? { draft: '', scrollTop: 0 };
}

export function updateChatDraft(conversationId: string, draft: string): void {
  const current = getChatState(conversationId);
  stateByConversation.set(conversationId, { ...current, draft });
}

export function updateChatScroll(conversationId: string, scrollTop: number): void {
  const current = getChatState(conversationId);
  stateByConversation.set(conversationId, { ...current, scrollTop });
}
